import {
  MCP_TIER_PRICES,
  MCP_TIER_QUOTAS,
  type McpTier,
  type SupportedCurrency,
  getMcpOverageRate,
  getMcpTierLabel,
} from '@kit/mcp/tier-config';

import styles from './pricing-mcp-plans.module.css';

const paidTiers: McpTier[] = ['lite', 'pro', 'max'];

export function PricingMcpPlans({ currency }: { currency: SupportedCurrency }) {
  const formatMoney = (amount: number) =>
    new Intl.NumberFormat('en', {
      style: 'currency',
      currency,
      maximumFractionDigits: amount % 1 ? 5 : 0,
    }).format(amount);

  return (
    <section className={styles.section} aria-labelledby="mcp-pricing-title">
      <span className={styles.eyebrow}>
        aXcelerate MCP · {currency} pricing
      </span>
      <h2 id="mcp-pricing-title">Connect your AI tools to aXcelerate.</h2>
      <p>
        The same MCP plans work standalone or alongside your Leagen chatbot. MCP
        calls and AI credits are separate allowances.
      </p>
      <div className={styles.grid}>
        {paidTiers.map((tier) => {
          const price = MCP_TIER_PRICES[currency][tier];
          const quota = MCP_TIER_QUOTAS[tier];
          const rate = getMcpOverageRate(tier, currency);
          return (
            <article key={tier}>
              <h3>{getMcpTierLabel(tier)}</h3>
              <strong className={styles.price}>
                {formatMoney(price)}
                <small>{currency} / month</small>
              </strong>
              <p className={styles.calls}>
                {quota.toLocaleString()} MCP calls included each month
              </p>
              <div className={styles.overage}>
                <span>Optional overage</span>
                <b>{formatMoney(rate)} per additional call</b>
                <small>
                  {formatMoney(rate * 1000)} {currency} per 1,000 additional
                  calls
                </small>
              </div>
            </article>
          );
        })}
      </div>
      <p className={styles.note}>
        MCP prices are shown in your selected currency. AI processing in Leagen
        uses workspace credits. When you use an external AI provider, that
        provider bills its AI usage separately.
      </p>
    </section>
  );
}
